interface StatsObject {
  statistics: {
    likeCount: number;
    viewCount: number;
    commentCount: number;
  };
}

export function aggregateStats(values: StatsObject[]) {
  return values.reduce(
    (acc, current) => ({
      likeCount: acc.likeCount + current.statistics.likeCount,
      viewCount: acc.viewCount + current.statistics.viewCount,
      commentCount: acc.commentCount + current.statistics.commentCount,
    }),
    { likeCount: 0, viewCount: 0, commentCount: 0 },
  );
}
